// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1XoCE","col":"Table_col__1gGxv","fulfillmentStatus":"Table_fulfillmentStatus__3PRKg","emailCol":"Table_emailCol__3o2OJ"};